import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb } from '@/fontawesome';
import type { ChatMessage } from '@/models/chat-message';

interface SystemQueryMessageProps {
  message: ChatMessage;
}

export default function SystemQueryMessage({ message }: SystemQueryMessageProps) {
  return (
    <div className="my-3">
      <div className="bg-yellow-50 dark:bg-yellow-900/30 rounded-lg p-3 w-full border border-yellow-200 dark:border-yellow-800">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <FontAwesomeIcon icon={faLightbulb} className="w-4 h-4 text-yellow-600 dark:text-yellow-400" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium text-yellow-800 dark:text-yellow-200 mb-1">
              System Query (Titel-Generierung)
            </div>
            {message.content && (
              <div className="bg-yellow-100 dark:bg-yellow-900/50 rounded p-2 max-h-20 overflow-auto w-full">
                <div className="text-sm text-yellow-700 dark:text-yellow-300 whitespace-pre-wrap">
                  {message.content}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}